import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  ParentQuestion,
  SearchQuestionsParams,
} from '../models/parent-question.model';
import { ParentQuestionApi } from '../api/parent-question.api';

@Injectable({ providedIn: 'root' })
export class ParentQuestionService {
  private readonly _api = inject(ParentQuestionApi);

  public searchQuestions(
    params: SearchQuestionsParams,
  ): Observable<ParentQuestion[]> {
    return this._api.searchQuestions(params);
  }
}
